<template>
  <div>
    {{ getPhoneNumber }}
    <el-tooltip content="Reject all inbound calls" placement="top" effect="light" v-if="rejectCalls" class="ml-1">
      <i class="fas fa-phone-slash"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {String}
     */
    getPhoneNumber() {
      return _.get(this.row, 'model.phone_number');
    },

    /**
     * @return {boolean}
     */
    rejectCalls() {
      return Boolean(_.get(this.row, 'model.reject_calls'));
    }
  },
}
</script>

<style scoped>

</style>
